export default __webpack_public_path__ + "static/media/Version (1) - Early Prop_08.e3d913f3.jpg";